module.exports = __webpack_public_path__ + "static/media/options.2b88e035.svg";